import { tryCatch } from '@wix/funnel-utils'

import { ambassadorHttpClient } from '../../../../api/httpClient'

export async function extractNameSuggestions(query: string): Promise<string[]> {
  const [error, nameSuggestions] = await tryCatch(async () => {
    if (query.length > 250) {
      throw new Error('query length should be less than 250')
    }
    const res = await ambassadorHttpClient.post('/_api/wildcat/extract/name-suggestions', { about: query })
    if (!res.data) {
      throw new Error('no response from extract request')
    }
    const { nameSuggestions } = res.data as { nameSuggestions: string[] }
    if (!nameSuggestions) {
      throw new Error('invalid response from extract name suggestions')
    }
    return nameSuggestions
  })
  if (error) {
    return []
  }
  return nameSuggestions
}
